import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchContracts } from '../apis/fetchContracts';
import type { contractData } from '../types/uploadContract';
import type { ApiResponse } from '../../../types/apiResponse';
import withPrefix from '../../../helpers/useQueryPrefix';

export const useFetchContracts = (): UseQueryResult<contractData[], Error> => {
	return useQuery<ApiResponse<contractData[]>, Error, contractData[]>({
		queryKey: withPrefix(['contracts']),
		queryFn: fetchContracts,
		select: (response) => {
			if (response.status !== 200) {
				throw new Error(response.message);
			}
			return response.data as contractData[];
		},
	});
};
